<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  export default {
    data () {
      return {
        
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      
    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: 'ajuan',

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: false,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Nomor Registrasi',
              width: '200px',
              value: 'ajuan_no_reg',
              freeze: false,
              hide: false
            },
            {
              text: 'Nama Lengkap',
              width: '300px',
              value: 'ajuan_pelapor_fullname',
              freeze: false,
              hide: false
            },
            {
              text: 'NIK',
              width: '200px',
              value: 'ajuan_pelapor_nik',
              freeze: false,
              hide: false
            },
            {
              text: 'Nomor Telepon',
              width: '200px',
              value: 'ajuan_pelapoor_phone',
              freeze: false,
              hide: false
            },
            {
              text: 'Nama Badan Usaha',
              width: '200px',
              value: 'ajuan_nama_badan_usaha',
              freeze: false,
              hide: false
            },
            {
              text: 'Nomor NIB',
              width: '200px',
              value: 'ajuan_nib_no',
              freeze: false,
              hide: false
            },
            {
              text: 'Alamat NIB',
              width: '400px',
              value: 'ajuan_nib_alamat',
              freeze: false,
              hide: false
            },
            {
              text: 'Kegiatan Usaha',
              width: '400px',
              value: 'ajuan_kbli_judul',
              freeze: false,
              hide: false
            },
            {
              text: 'Lokasi Usaha',
              width: '400px',
              value: 'ajuan_lokasi_usaha',
              freeze: false,
              hide: false
            },
            {
              text: 'Kecamatan',
              width: '200px',
              value: 'ajuan_kecamatan_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Kelurahan',
              width: '200px',
              value: 'ajuan_kelurahan_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Dukuh',
              width: '400px',
              value: 'ajuan_dukuh',
              freeze: false,
              hide: false
            },
            {
              text: 'RT',
              width: '100px',
              value: 'ajuan_rt',
              freeze: false,
              hide: false
            },
            {
              text: 'RW',
              width: '100px',
              value: 'ajuan_rw',
              freeze: false,
              hide: false
            },
            {
              text: 'Luas (M2)',
              width: '200px',
              value: 'ajuan_luas',
              freeze: false,
              hide: false
            },
            {
              text: 'Diajukan Tanggal',
              width: '200px',
              value: 'ajuan_create_datetime',
              freeze: false,
              hide: false,
              format: 'datetime'
            },
            {
              text: 'Status',
              width: '200px',
              value: 'ajuan_status',
              freeze: false,
              hide: false
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // PREFIX KEY
          prefix: 'ajuan_',

          // CONFIG PARSING FORM
          form: [],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: true,
              api: [
                {
                  text: 'MENUNGGU VERIFIKASI',
                  value: 'MENUNGGU VERIFIKASI'
                },
                {
                  text: 'DIPROSES',
                  value: 'DIPROSES'
                },
                {
                  text: 'DISETUJUI',
                  value: 'DISETUJUI'
                },
                {
                  text: 'DITOLAK',
                  value: 'DITOLAK'
                },
                {
                  text: 'DIKOREKSI',
                  value: 'DIKOREKSI'
                },
                {
                  text: 'DIHAPUS',
                  value: 'DIHAPUS'
                }
              ],
              field: 'ajuan_status'
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            edit: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            delete: {
              button: false,
              api: ''
            },
            detail: {
              button: true,
              api: '/service/submission/'
            },
            active: {
              button: false,
              api: ''
            },
            deactive: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: true,
              api: ''
            }
          }
        }
      }
    }
  }
</script>